import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerOnboardingService } from '../services/customer-onboarding/customer-onboarding.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';

@Component({
  selector: 'app-spectacle-vendors',
  templateUrl: './spectacle-vendors.component.html',
  styleUrls: ['./spectacle-vendors.component.css']
})
export class SpectacleVendorsComponent implements OnInit {

  customersOnboarded: any[] = [];
  constructor(private router: Router, private onboardingService: CustomerOnboardingService,
    private foruscareService: ForuscareService) { }

  getOnboardingUsers() {
    this.onboardingService.getInvitedVendors()
      .subscribe(response => {
        if (response.status == 200) {
          if (response.data != null && response.data != null) {
            this.customersOnboarded = response.data.response;
          }
        }
        else {
        }
      });
  }

  ngOnInit(): void {
    this.getOnboardingUsers();
  }

  resendLink(data) {
    if (data == null || data.id == null || data.id.trim().length == 0) {
      return;
    }
    this.onboardingService.resendInviteLink(data.id)
      .subscribe(response => {
        if (response.status == 200) {
          this.foruscareService.showNotification("Invite link sent successfully.",
            "success");
          this.getOnboardingUsers();
        }
        else {
          this.foruscareService.showNotification("Something went wrong, please try again.",
            "danger");
        }
      });
  }

  inviteNewVendor() {
    this.router.navigate(['/spectacle/vendor/info']);
  }
}
